(function () {
  var track = document.getElementById('featuresTrack');
  var navBtns = document.querySelectorAll('[data-features-nav]');
  if (!track || !navBtns.length) return;
  var items = Array.prototype.slice.call(track.querySelectorAll('.features__item'));
  if (!items.length) return;

  function nearestIndex() {
    var pos = track.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    items.forEach(function (item, i) {
      var dist = Math.abs(item.offsetLeft - pos);
      if (dist < closestDist) { closestDist = dist; closest = i; }
    });
    return closest;
  }

  var mobileQuery = window.matchMedia('(max-width: 640px)');
  function pageSize() {
    return mobileQuery.matches ? 1 : 3;
  }

  navBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = parseFloat(btn.getAttribute('data-features-nav')) || 1;
      var idx = Math.max(0, Math.min(items.length - 1, nearestIndex() + dir * pageSize()));
      track.scrollTo({ left: items[idx].offsetLeft, behavior: 'smooth' });
    });
  });
})();

(function () {
  try {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (reduceMotion || !targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    document.documentElement.classList.add('js-reveal');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  } catch (e) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }
})();

(function () {
  var list = document.getElementById('faqList');
  if (!list) return;
  var items = Array.prototype.slice.call(list.querySelectorAll('.faq__item'));

  function setOpen(item, open) {
    var btn = item.querySelector('.faq__question');
    var panel = item.querySelector('.faq__answer');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  items.forEach(function (item) {
    var btn = item.querySelector('.faq__question');
    btn.addEventListener('click', function () {
      var willOpen = !item.classList.contains('is-open');
      items.forEach(function (other) { setOpen(other, false); });
      setOpen(item, willOpen);
    });
    setOpen(item, item.classList.contains('is-open'));
  });

  window.addEventListener('resize', function () {
    items.forEach(function (item) {
      if (item.classList.contains('is-open')) {
        item.querySelector('.faq__answer').style.maxHeight = item.querySelector('.faq__answer').scrollHeight + 'px';
      }
    });
  });
})();

(function () {
  var lightbox = document.getElementById('lightbox');
  var lightboxImg = document.getElementById('lightboxImg');
  var closeBtn = document.getElementById('lightboxClose');
  if (!lightbox || !lightboxImg) return;

  function open(src, alt) {
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    lightbox.hidden = true;
    lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.features__zoom').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      open(btn.getAttribute('data-full'), btn.getAttribute('data-alt'));
    });
  });

  closeBtn.addEventListener('click', close);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lightbox.hidden) close();
  });
})();

(function () {
  try {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stage = document.querySelector('.hero__stage');
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-drift]'));
    if (reduceMotion || !stage || !cards.length) return;

    document.documentElement.classList.add('js-scroll');

    var DRIFT = 72;      // px each card travels outward as it drifts
    var ticking = false;

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }

    function apply() {
      ticking = false;
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      // tracks the dashboard image itself: starts drifting once its top has scrolled
      // past the lower half of the viewport, and finishes right as its top reaches the
      // viewport's top edge — so the whole drift plays out while the image is still on
      // screen, not after it has already scrolled away under the next section.
      var startY = vh * 0.55;
      var exit = clamp01((startY - rect.top) / startY);
      var eased = exit * exit; // ease-in

      cards.forEach(function (card) {
        var dx = parseFloat(card.getAttribute('data-dir-x')) || 0;
        var dy = parseFloat(card.getAttribute('data-dir-y')) || 0;
        card.style.transform = 'translate(' + (eased * DRIFT * dx).toFixed(1) + 'px, ' + (eased * DRIFT * dy).toFixed(1) + 'px)';
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(apply);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  } catch (e) {
    document.querySelectorAll('[data-scroll-drift]').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }
})();
